/**
 * OVERKILL session settings (Faz 7.7 — OCS modify/overkill.rs Settings).
 * The command remembers its options for the session (not persisted):
 * tolerance, the ignore bitmask (which property differences block a merge)
 * and the four behavior toggles.
 */

import { create } from 'zustand';

/** OCS ignore bitmask: 1 Color, 2 Layer, 4 Ltype, 8 Ltscale, 16 LWeight,
 *  32 Thickness, 64 Transparency, 128 Plotstyle, 256 Material; All = 511. */
export const OVERKILL_IGNORE_ALL = 511;

export interface OverkillSettings {
    tolerance: number;
    ignore: number;
    optimize: boolean;
    overlap: boolean;
    endToEnd: boolean;
    associativity: boolean;
}

interface OverkillState extends OverkillSettings {
    set: (patch: Partial<OverkillSettings>) => void;
}

export const useOverkillStore = create<OverkillState>((set) => ({
    tolerance: 1e-6,
    ignore: 0,
    optimize: true,
    overlap: true,
    endToEnd: true,
    associativity: true,
    set: (patch) => set(patch),
}));
